import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { WorkpaperProcedure } from '../types/workpaper-procedure';
import { AxiosError } from 'axios';

export type GetProcedureResponse = {
    workpaperProcedure: WorkpaperProcedure;
};

async function getWorkpaperProcedure(workpaperProcedure: string, procedureId?: string): Promise<GetProcedureResponse> {
    const { data } = await api.get(`/workpapers/${workpaperProcedure}/procedures/${procedureId}`);
    return data;
}

export function useWorkpaperProcedure(workpaperProcedure: string, procedureId?: string): UseQueryResult<GetProcedureResponse, AxiosError> {
    return useQuery(
        ['workpapers', workpaperProcedure, 'procedures', procedureId],
        () => getWorkpaperProcedure(workpaperProcedure, procedureId),
        {
            enabled: Boolean(procedureId),
            keepPreviousData: false,
        }
    );
}
